<div class="c-portlet o-block u-width-100p _u-width-100p u-shadow-mini u-bg-primary">
	<app-loader [showLoader]="showLoad"></app-loader>
	<div
		class="c-portlet__header o-stack o-stack--center o-stack--splitted u-border-bottom u-px-small u-py-mini c-portlet-gap u-border-bottom {{
			sectionclass
		}}"
	>
		<div class="o-stack__cell">
			<h5 class="card-title">
				{{ sectiontitle }}
				<span *ngIf="(tableConfig?.enableDownload || downloadConfiguration?.enableDownload) && hasData" class="datatable-icon">
					<a
						href="javascript:void(0)"
						class="datatable_download_icon r6_datatable_download_icon"
						(click)="downloadCSV($event)"
						target="_blank"
					>
						<img *ngIf="downloadIcon" class="download-icon-svg downloadIcon" src="{{ downloadIcon }}" />
						<i class="fa fa-download" aria-hidden="true" *ngIf="!tableConfig.downloadPNGIcon && !downloadIcon"></i>
						<img
							*ngIf="tableConfig.downloadPNGIcon && !downloadIcon"
							class="download-icon-svg"
							src="../../../../../assets/images/Download_Icon_R7.svg"
						/>
					</a>
				</span>
			</h5>
		</div>
	</div>
	<div
		class="analytics-portlet-content analytics-portlet-content_r7"
		[ngClass]="{ 'analytics-datatable-scrollable': isVerticalScrollable }"
	>
		<ngx-datatable
			style="height: 100%"
			class="datatable ngx-datatable {{ sectionclass }}ngx-datatable"
			[columns]="dataTableObj.columns"
			[offset]="currentPage"
			[rows]="dataTableObj.data"
			[sortType]="'single'"
			[cssClasses]="cssClasses"
			(sort)="onSort($event)"
			[columnMode]="'force'"
			[headerHeight]="50"
			[footerHeight]="footerHeight"
			[rowHeight]="rowHeight"
			[messages]="{ emptyMessage: nodatamessage ? nodatamessage : 'No data to display' }"
			[limit]="dataTableObj.limit"
			[reorderable]="reorderable"
			(activate)="onUserEvent($event)"
			[scrollbarV]="isVerticalScrollable"
			(page)="onPageChange($event)"
		>
			<ng-template ngFor let-column [ngForOf]="dataTableObj.columns">
				<ngx-datatable-column
					name="{{ column.name }}"
					prop="{{ column.prop }}"
					[resizeable]="false"
					[sortable]="true"
					[cellClass]="column.cellClass"
					[headerClass]="column.headerClass"
					[comparator]="column.comparator"
				>
					<ng-template let-colHeader="column" let-sort="sortFn" ngx-datatable-header-template>
						<span
							(click)="column.prop == 'date' ? customSort(column.prop) : sort()"
							class="cursor-pointer"
							[title]="colHeader.name"
							*ngIf="!column.columnHasTooltip; else elseBlock"
						>
							{{ colHeader.name }}
						</span>
						<ng-template #elseBlock>
							<span class="cursor-pointer">
								<span
									(click)="sort()"
									appTooltip
									title="Tooltip"
									[title]="column.columnTooltip"
									data-size="small"
									[options]="tooltipOptions"
								>
									{{ colHeader.name }}
								</span>
							</span>
						</ng-template>
					</ng-template>
					<ng-template let-row="row" let-value="value" ngx-datatable-cell-template>
						<div class="network-div" *ngIf="column.columnDisplayImage">
							<div class="network-logo" [ngStyle]="{ 'background-image': 'url(' + row['favicon_url'] + ')' }"></div>
							<div class="network-name" [title]="row.place">{{ row['place'] }}</div>
						</div>

						<span *ngIf="!column.columnDisplayImage && !isemail" [title]="row[column.prop]">
							{{ row[column.prop] }}
						</span>

						<span
							*ngIf="!column.columnDisplayImage && isemail"
							appTooltip
							title="Tooltip"
							data-size="small"
							[options]="tooltipOptions"
							[title]="row[column.prop]"
						>
							{{ row[column.prop] }}
						</span>
					</ng-template>
				</ngx-datatable-column>
			</ng-template>
		</ngx-datatable>
	</div>
</div>
